/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IAcknowledgeAllModalScope extends ng.IScope {
        modalClose: () => void;
        modalSave: () => void;
        comment: string;
        monitorName: string;
        sourceName: string;
        sinkName: string;
        extraNames?:string[];
    }

    /**
     * AcknowledgeModalController class
     */
    export class AcknowledgeAllModalController {
        public static templateURL: string = "decorators/modals/acknowledge-all-modal.html";
        public static ID: string = "#id-acknowledge-all-modal";
        public static $name: string = "acknowledgeAllModalController";
        public static $inject: string[] = ['$scope', 'alarmsService', 'close', '$timeout', 'monitorName', 'sourceName', 'sinkName','extraNames'];

        /**
         * Constructor
         */
        constructor($scope: IAcknowledgeAllModalScope,
                    alarmsService: Services.AlarmsService,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    monitorName: string,
                    sourceName: string,
                    sinkName: string,
                    extraNames?:string[]) {
            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);

            $scope.monitorName = monitorName;
            $scope.sourceName = sourceName;
            $scope.sinkName = sinkName;
            $scope.extraNames = extraNames ? extraNames : [];

            $scope.comment = '';

            $scope.modalClose = (): void => {
                close(undefined);
            };

            $scope.modalSave = (): void => {
                close($scope.comment);
            };
        }
    }
}
